import React from 'react';
import { EmptyStateCardBody } from '../../components/EmptyStateCard';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';

const i18Path = 'documents2.corporate.table';

export const EmptyFolderDocuments: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const t = useNamespacedTranslation(i18Path);

  return (
    <EmptyStateCardBody
      title={t('emptyFolder.title')}
      subtitle={t('emptyFolder.subtitle')}
    />
  );
};
